import { render } from "./UserList.vue?vue&type=template&id=74e0b084"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
script.render = render

export default script